module.exports = __webpack_public_path__ + "static/media/s-home_formats_meeting.1c960198.jpg";